import * as Yup from "yup";

const CountrySchema = Yup.object().shape({
  title: Yup.string().required("Please enter a title").strict().trim(),
  status: Yup.string().oneOf(["active", "inactive"]).default("active"),
});

export default CountrySchema;
